<template>
  <div>
    <div class="tab-content-file default-body">
      <div class="default">
        <img src="@/assets/default.png" alt="" />
      </div>
      <div class="tips">
        {{ tips }}
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  export default {
    // import引入的组件需要注入到对象中才能使用
    props: {
      tips: {
        type: String,
        default: '没有找到记录～'
      }
    },
    components: {},
    data() {
      // 这里存放数据
      return {

      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  .tab-content-file {
    height: calc(100vh - 260px);
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  }
  .default-body {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .default {
      width: 100px;
      height: 100px;
      img {
        width: 100px;
        height: 100px;
      }
    }
    .tips {
      color: #999999;
      font-size: 13px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/empty.vue